// Leave for legacy reference, currently an unusued file

import ADAValidator from "./validators/cardano_validator";
import AEValidator from "./validators/ae_validator";
import ALGOValidator from "./validators/algo_validator";
import APTValidator from "./validators/apt_validator";
import ARDRValidator from "./validators/ardr_validator";
import ATOMValidator from "./validators/atom_validator";
import AVAXValidator from "./validators/avax_validator";
import BCHValidator from "./validators/bitcoincash_validator";
import BNBValidator from "./validators/bnb_validator";
import BTCValidator from "./validators/bitcoin_validator";
import BTSValidator from "./validators/bts_validator";
import COREUMValidator from "./validators/coreum_validator";
import DOTValidator from "./validators/dot_validator";
import EGLDValidator from "./validators/egld_validator";
import EOSValidator from "./validators/eos_validator";
import ETHValidator from "./validators/ethereum_validator";
import FILValidator from "./validators/fil_validator";
import FLOWValidator from "./validators/flow_validator";
import HBARValidator from "./validators/hbar_validator";
import HBARTESTNETValidator from "./validators/hbartestnet_validator";
import ICPValidator from "./validators/icp_validator";
import ICXValidator from "./validators/icx_validator";
import IOSTValidator from "./validators/iost_validator";
import IOTAValidator from "./validators/iota_validator";
import KDAValidator from "./validators/kadena_validator";
import KMDValidator from "./validators/kmd_validator";
import LRCValidator from "./validators/lrc_validator";
import LSKValidator from "./validators/lisk_validator";
import LTCValidator from "./validators/ltc_validator";
import MOBValidator from "./validators/mob_validator";
import NANOValidator from "./validators/nano_validator";
import NEARValidator from "./validators/near_validator";
import NEMValidator from "./validators/nem_validator";
import NXSValidator from "./validators/nxs_validator";
import ONEValidator from "./validators/one_validator";
import RONValidator from "./validators/ronin_validator";
import RBXValidator from "./validators/rbx_validator";
import SCValidator from "./validators/sc_validator";
import SOLValidator from "./validators/sol_validator";
import STARKWAREValidator from "./validators/starkware_validator";
import STEEMValidator from "./validators/steem_validator";
import STXValidator from "./validators/stx_validator";
import SUIValidator from "./validators/sui_validator";
import SYSValidator from "./validators/sys_validator";
import TERRAValidator from "./validators/terra_validator";
import THORCHAINValidator from "./validators/thorchain_validator";
import TONValidator from "./validators/ton_validator";
import WAXValidator from "./validators/wax_validator";
import XCHValidator from "./validators/xch_validator";
import XLMValidator from "./validators/lumen_validator";
import XPRTValidator from "./validators/xprt_validator";
import XMRValidator from "./validators/monero_validator";
import XRPValidator from "./validators/ripple_validator";
import XTZValidator from "./validators/xtz_validator";
import ZILValidator from "./validators/zil_validator";
import DYDXValidator from "./validators/dydx_validator";
import LNValidator from "./validators/ln_validator";
import ALPHValidator from "./validators/alph_validator";
import VENOMValidator from "./validators/venom_validator";
import FUELValidator from "./validators/fuel_validator";
import GALACHAINValidator from "./validators/galachain_validator";
import INJValidator from "./validators/inj_validator";
import QRLValidator from "./validators/qrl_validator";
import POLYXValidator from "./validators/polyx_validator";
import CCDValidator from "./validators/ccd_validator";
import SUPRAValidator from "./validators/supra_validator";
import QValidator from "./validators/q_validator";
import ERGOValidator from "./validators/ergo_validator";

// defines P2PKH and P2SH address types for standard (prod) and testnet networks
export const CURRENCIES = [
    {
        name: "Algorand",
        symbol: "algo",
        validator: ALGOValidator,
    },
    {
        name: "Bitcoin",
        symbol: "btc",
        addressTypes: { prod: ["00", "05"], testnet: ["6f", "c4"] },
        validator: BTCValidator,
    },
    {
        name: "BitcoinCash",
        symbol: "bch",
        addressTypes: { prod: ["00", "05"], testnet: ["6f", "c4"] },
        validator: BCHValidator,
    },
    {
        name: "Bitcoin SV",
        symbol: "bsv",
        addressTypes: { prod: ["00", "05"], testnet: ["6f", "c4"] },
        validator: BCHValidator,
    },
    {
        name: "Bitcoin SV",
        symbol: "bchsv",
        addressTypes: { prod: ["00", "05"], testnet: ["6f", "c4"] },
        validator: BCHValidator,
    },
    {
        name: "BitcoinCash",
        symbol: "bcc", // Other asset code for Bitcoin Cash
        addressTypes: { prod: ["00", "05"], testnet: ["6f", "c4"] },
        validator: BTCValidator,
    },
    {
        name: "LiteCoin",
        symbol: "ltc",
        addressTypes: { prod: ["30", "05", "32"], testnet: ["6f", "c4", "3a"] },
        validator: LTCValidator,
    },
    {
        name: "Tron",
        symbol: "trx",
        addressTypes: { prod: ["41"] },
        validator: BTCValidator,
    },
    {
        name: "Tron",
        symbol: "tron",
        addressTypes: { prod: ["41"] },
        validator: BTCValidator,
    },
    {
        name: "Tron Network",
        symbol: "trc20",
        addressTypes: { prod: ["41"] },
        validator: BTCValidator,
    },
    {
        name: "DogeCoin",
        symbol: "doge",
        addressTypes: { prod: ["1e", "16"], testnet: ["71", "c4"] },
        validator: BTCValidator,
    },
    {
        name: "Dingo",
        symbol: "dingo",
        addressTypes: { prod: ["1e", "16"], testnet: ["71", "c4"] },
        validator: BTCValidator,
    },
    {
        name: "Moonbeam",
        symbol: "glmr",
        validator: ETHValidator,
    },
    {
        name: "Flare",
        symbol: "flr",
        validator: ETHValidator,
    },
    {
        name: "VertCoin",
        symbol: "vtc",
        addressTypes: { prod: ["0x", "47"], testnet: ["6f", "c4"] },
        validator: BTCValidator,
    },
    {
        name: "BitcoinGold",
        symbol: "btg",
        addressTypes: { prod: ["26", "17"], testnet: ["6f", "c4"] },
        validator: BTCValidator,
    },
    {
        name: "Komodo",
        symbol: "kmd",
        addressTypes: { prod: ["3c", "55"], testnet: ["0", "5"] },
        validator: BTCValidator,
    },
    {
        name: "BitcoinZ",
        symbol: "btcz",
        expectedLength: 26,
        addressTypes: { prod: ["1cb8", "1cbd"], testnet: ["1d25", "1cba"] },
        validator: BTCValidator,
    },
    {
        name: "ZenCash",
        symbol: "zen",
        expectedLength: 26,
        addressTypes: { prod: ["2089", "2096"], testnet: ["2092", "2098"] },
        validator: BTCValidator,
    },
    {
        name: "VoteCoin",
        symbol: "vot",
        expectedLength: 26,
        addressTypes: { prod: ["1cb8", "1cbd"], testnet: ["1d25", "1cba"] },
        validator: BTCValidator,
    },
    {
        name: "Decred",
        symbol: "dcr",
        addressTypes: { prod: ["073f", "071a"], testnet: ["0f21", "0efc"] },
        hashFunction: "blake256",
        expectedLength: 26,
        validator: BTCValidator,
    },
    {
        name: "GameCredits",
        symbol: "game",
        addressTypes: { prod: ["26", "05"], testnet: [] },
        validator: BTCValidator,
    },
    {
        name: "PIVX",
        symbol: "pivx",
        addressTypes: { prod: ["1e", "0d"], testnet: [] },
        validator: BTCValidator,
    },
    {
        name: "SolarCoin",
        symbol: "slr",
        addressTypes: { prod: ["12", "05"], testnet: [] },
        validator: BTCValidator,
    },
    {
        name: "MonaCoin",
        symbol: "mona",
        addressTypes: { prod: ["32", "37"], testnet: [] },
        validator: BTCValidator,
    },
    {
        name: "DigiByte",
        symbol: "dgb",
        addressTypes: { prod: ["1e"], testnet: [] },
        validator: BTCValidator,
    },
    {
        name: "Tether",
        symbol: "usdt",
        validator: ETHValidator,
    },
    {
        name: "Ripple",
        symbol: "xrp",
        validator: XRPValidator,
    },
    {
        name: "Dash",
        symbol: "dash",
        addressTypes: { prod: ["4c", "10"], testnet: ["8c", "13"] },
        validator: BTCValidator,
    },
    {
        name: "Neo",
        symbol: "neo",
        addressTypes: { prod: ["17"], testnet: [] },
        validator: BTCValidator,
    },
    {
        name: "NeoGas",
        symbol: "gas",
        addressTypes: { prod: ["17"], testnet: [] },
        validator: BTCValidator,
    },
    {
        name: "Qtum",
        symbol: "qtum",
        addressTypes: { prod: ["3a", "32"], testnet: ["6f", "c4"] },
        validator: BTCValidator,
    },
    {
        name: "Verge",
        symbol: "xvg",
        addressTypes: { prod: ["1e"], testnet: ["6F"] },
        validator: BTCValidator,
    },
    {
        name: "Waves",
        symbol: "waves",
        addressTypes: { prod: ["0157"], testnet: ["0154"] },
        expectedLength: 26,
        hashFunction: "blake256keccak256",
        regex: /^[a-zA-Z0-9]{35}$/,
        validator: BTCValidator,
    },
    {
        name: "Ethereum",
        symbol: "eth",
        validator: ETHValidator,
    },
    {
        name: "Binance Smart Chain",
        symbol: "bep20",
        validator: ETHValidator,
    },
    {
        name: "Binance Smart Chain",
        symbol: "bsc",
        validator: ETHValidator,
    },
    {
        name: "Kucoin Community Chain",
        symbol: "kcs",
        validator: ETHValidator,
    },
    {
        name: "EtherZero",
        symbol: "etz",
        validator: ETHValidator,
    },
    {
        name: "EthereumClassic",
        symbol: "etc",
        validator: ETHValidator,
    },
    {
        name: "Enigma",
        symbol: "eng",
        validator: ETHValidator,
    },
    {
        name: "Callisto",
        symbol: "clo",
        validator: ETHValidator,
    },
    {
        name: "Bankex",
        symbol: "bkx",
        validator: ETHValidator,
    },
    {
        name: 'Cardano',
        symbol: 'ada',
        validator: ADAValidator,
        bech32Hrp: { prod: ['addr'], testnet: ['addr'] },
    },
    {
        name: "Monero",
        symbol: "xmr",
        addressTypes: { prod: ["18", "42"], testnet: ["53", "63"] },
        iAddressTypes: { prod: ["19"], testnet: ["54"] },
        validator: XMRValidator,
    },
    {
        name: "Aragon",
        symbol: "ant",
        validator: ETHValidator,
    },
    {
        name: "BasicAttentionToken",
        symbol: "bat",
        validator: ETHValidator,
    },
    {
        name: "Bancor",
        symbol: "bnt",
        validator: ETHValidator,
    },
    {
        name: "Civic",
        symbol: "cvc",
        validator: ETHValidator,
    },
    {
        name: "District0x",
        symbol: "dnt",
        validator: ETHValidator,
    },
    {
        name: "Gnosis",
        symbol: "gno",
        validator: ETHValidator,
    },
    {
        name: "Golem",
        symbol: "gnt",
        validator: ETHValidator,
    },
    {
        name: "Matchpool",
        symbol: "gup",
        validator: ETHValidator,
    },
    {
        name: "Melon",
        symbol: "mln",
        validator: ETHValidator,
    },
    {
        name: "Numeraire",
        symbol: "nmr",
        validator: ETHValidator,
    },
    {
        name: "OmiseGO",
        symbol: "omg",
        validator: ETHValidator,
    },
    {
        name: "TenX",
        symbol: "pay",
        validator: ETHValidator,
    },
    {
        name: "RipioCreditNetwork",
        symbol: "rcn",
        validator: ETHValidator,
    },
    {
        name: "Augur",
        symbol: "rep",
        validator: ETHValidator,
    },
    {
        name: "iExec RLC",
        symbol: "rlc",
        validator: ETHValidator,
    },
    {
        name: "Salt",
        symbol: "salt",
        validator: ETHValidator,
    },
    {
        name: "Status",
        symbol: "snt",
        validator: ETHValidator,
    },
    {
        name: "Storj",
        symbol: "storj",
        validator: ETHValidator,
    },
    {
        name: "Swarm City",
        symbol: "swt",
        validator: ETHValidator,
    },
    {
        name: "TrueUSD",
        symbol: "tusd",
        validator: ETHValidator,
    },
    {
        name: "Wings",
        symbol: "wings",
        validator: ETHValidator,
    },
    {
        name: "0x",
        symbol: "zrx",
        validator: ETHValidator,
    },
    {
        name: "Expanse",
        symbol: "exp",
        validator: ETHValidator,
    },
    {
        name: "Viberate",
        symbol: "vib",
        validator: ETHValidator,
    },
    {
        name: "Odyssey",
        symbol: "ocn",
        validator: ETHValidator,
    },
    {
        name: "Polymath",
        symbol: "poly",
        validator: ETHValidator,
    },
    {
        name: "Storm",
        symbol: "storm",
        validator: ETHValidator,
    },
    {
        name: "Nano",
        symbol: "nano",
        validator: NANOValidator,
    },
    {
        name: "RaiBlocks",
        symbol: "xrb",
        validator: NANOValidator,
    },
    {
        name: "AdEx",
        symbol: "adx",
        validator: ETHValidator,
    },
    {
        name: "Binance Coin",
        symbol: "bnb", // bep
        validator: BNBValidator,
    },
    {
        name: "ETHOS",
        symbol: "ethos",
        validator: ETHValidator,
    },
    {
        name: "Bitquence",
        symbol: "bqx",
        validator: ETHValidator,
    },
    {
        name: "FunFair",
        symbol: "fun",
        validator: ETHValidator,
    },
    {
        name: "Monacao",
        symbol: "mco",
        validator: ETHValidator,
    },
    {
        name: "PowerLedger",
        symbol: "powr",
        validator: ETHValidator,
    },
    {
        name: "Substratum",
        symbol: "sub",
        validator: ETHValidator,
    },
    {
        name: "Lisk",
        symbol: "lsk",
        validator: LSKValidator,
    },
    {
        name: "Iota",
        symbol: "iota",
        validator: IOTAValidator,
    },
    {
        name: "EOS",
        symbol: "eos",
        validator: EOSValidator,
    },
    {
        name: "BitTorrent",
        symbol: "btt",
        addressTypes: { prod: ["41"] },
        validator: BTCValidator,
    },
    {
        name: "Dent",
        symbol: "dent",
        validator: ETHValidator,
    },
    {
        name: "Holo",
        symbol: "HOT",
        validator: ETHValidator,
    },
    {
        name: "Chainlink",
        symbol: "link",
        validator: ETHValidator,
    },
    {
        name: "Metal",
        symbol: "mtl",
        validator: ETHValidator,
    },
    {
        name: "Pundi X",
        symbol: "npxs",
        validator: ETHValidator,
    },
    {
        name: "Stellar Lumens",
        symbol: "xlm",
        validator: XLMValidator,
    },
    {
        name: "Zilliqa",
        symbol: "zil",
        validator: ZILValidator,
    },
    {
        name: "Syscoin",
        symbol: "sys",
        addressTypes: { prod: ["3f"] },
        validator: SYSValidator,
    },
    {
        name: "Populous",
        symbol: "ppt",
        validator: ETHValidator,
    },
    {
        name: "VeChain",
        symbol: "vet",
        validator: ETHValidator,
    },
    {
        name: "Ontology",
        symbol: "ont",
        validator: BTCValidator,
        addressTypes: { prod: ["17", "41"] },
    },
    {
        name: "Ontology Gas",
        symbol: "ong",
        validator: BTCValidator,
        addressTypes: { prod: ["17", "41"] },
    },
    {
        name: "NEM",
        symbol: "xem",
        validator: NEMValidator,
        addressTypes: { prod: ["17", "41"] },
    },
    {
        name: "USD Coin",
        symbol: "usdc",
        validator: ETHValidator,
    },
    {
        name: "Bitcoin Diamond",
        symbol: "bcd",
        validator: BTCValidator,
        addressTypes: { prod: ["00"] },
    },
    {
        name: "Ravencoin",
        symbol: "rvn",
        validator: BTCValidator,
        addressTypes: { prod: ["3c"] },
    },
    {
        name: "Bitshares",
        symbol: "bts",
        validator: BTSValidator,
    },
    {
        name: "ICON",
        symbol: "icx",
        validator: ICXValidator,
    },
    {
        name: "Paxos Standard Token",
        symbol: "pax",
        validator: ETHValidator,
    },
    {
        name: "Aeternity",
        symbol: "ae",
        validator: AEValidator,
    },
    {
        name: "Siacoin",
        symbol: "sc",
        validator: SCValidator,
    },
    {
        name: "Cosmos",
        symbol: "atom",
        validator: ATOMValidator,
    },
    {
        name: "STEEM",
        symbol: "steem",
        validator: STEEMValidator,
    },
    {
        name: "Blockstack",
        symbol: "stx",
        validator: STXValidator,
    },
    {
        name: "Enjin Coin",
        symbol: "enj",
        validator: ETHValidator,
    },
    {
        name: "THETA",
        symbol: "theta",
        validator: ETHValidator,
    },
    {
        name: "Stratis",
        symbol: "strat",
        validator: BTCValidator,
        addressTypes: { prod: ["3f"] },
    },
    {
        name: "Golem",
        symbol: "gnt",
        validator: ETHValidator,
    },
    {
        name: "aelf",
        symbol: "ELF",
        validator: ETHValidator,
    },
    {
        name: "Ardor",
        symbol: "ardr",
        validator: ARDRValidator,
    },
    {
        name: "Horizen",
        symbol: "zen",
        expectedLength: 26,
        addressTypes: { prod: ["2089", "2096"], testnet: ["2092", "2098"] },
        validator: BTCValidator,
    },
    {
        name: "Aave",
        symbol: "lend",
        validator: ETHValidator,
    },
    {
        name: "Nexus",
        symbol: "nxs",
        validator: NXSValidator,
    },
    {
        name: "Internet of Services",
        symbol: "IOST",
        validator: IOSTValidator,
    },
    {
        name: "Decentraland",
        symbol: "MANA",
        validator: ETHValidator,
    },
    {
        name: "iExec RLC",
        symbol: "RLC",
        validator: ETHValidator,
    },
    {
        name: "Tezos",
        symbol: "XTZ",
        validator: XTZValidator,
    },
    {
        name: "Hedera Hashgraph",
        symbol: "hbar",
        validator: HBARValidator,
    },
    {
        name: "Hedera Hashgraph Testnet",
        symbol: "hbartestnet",
        validator: HBARTESTNETValidator,
    },
    {
        name: "Terra",
        symbol: "luna",
        validator: TERRAValidator,
    },
    {
        name: "Wax",
        symbol: "wax",
        validator: WAXValidator,
    },
    {
        name: "Binance USD",
        symbol: "busd",
        validator: ETHValidator,
    },
    {
        name: "Compound",
        symbol: "comp",
        validator: ETHValidator,
    },
    {
        name: "Chiliz",
        symbol: "chz",
        validator: ETHValidator,
    },
    {
        name: "KuCoin Token",
        symbol: "kcs",
        validator: ETHValidator,
    },
    {
        name: "KuCoin Token",
        symbol: "kcc",
        validator: ETHValidator,
    },
    {
        name: "Uniswap",
        symbol: "uni",
        validator: ETHValidator,
    },
    {
        name: "Wrapped Bitcoin",
        symbol: "wbtc",
        validator: ETHValidator,
    },
    {
        name: "True USD",
        symbol: "tusd",
        validator: ETHValidator,
    },
    {
        name: "Sushi Swap",
        symbol: "sushi",
        validator: ETHValidator,
    },
    {
        name: "Paxos Standard",
        symbol: "pax",
        validator: ETHValidator,
    },
    {
        name: "PAX Gold",
        symbol: "paxg",
        validator: ETHValidator,
    },
    {
        name: "Maker",
        symbol: "mkr",
        validator: ETHValidator,
    },
    {
        name: "Pancake Swap",
        symbol: "cake",
        validator: BNBValidator,
    },
    {
        name: "Axie Infinity",
        symbol: "axs",
        validator: ETHValidator,
    },
    {
        name: "AAVE",
        symbol: "aave",
        validator: ETHValidator,
    },
    {
        name: "Polygon",
        symbol: "matic",
        validator: ETHValidator,
    },
    {
        name: "Arbitum",
        symbol: "arb",
        validator: ETHValidator,
    },
    {
        name: "Celo",
        symbol: "celo",
        validator: ETHValidator,
    },
    {
        name: "Polkadot",
        symbol: "dot",
        prefix: 0,
        validator: DOTValidator,
    },
    {
        name: "Kusama",
        symbol: "ksm",
        prefix: 2,
        validator: DOTValidator,
    },
    {
        name: "Ternoa",
        symbol: "ternoa",
        prefix: 42,
        validator: DOTValidator,
    },
    {
        name: "Avalanche",
        symbol: "avax",
        validator: AVAXValidator,
    },
    {
        name: "Avalanche",
        symbol: "avax-x",
        validator: AVAXValidator,
    },
    {
        name: "Avalanche",
        symbol: "avax-c",
        validator: ETHValidator,
    },
    {
        name: "Avalanche",
        symbol: "xchain",
        validator: AVAXValidator,
    },
    {
        name: "Avalanche",
        symbol: "x-chain",
        validator: AVAXValidator,
    },
    {
        name: "Solana",
        symbol: "sol",
        validator: SOLValidator,
    },
    {
        name: "Filecoin",
        symbol: "fil",
        validator: FILValidator,
    },
    {
        name: "Klayton",
        symbol: "klay",
        validator: ETHValidator,
    },
    {
        name: "Optimism",
        symbol: "optimism",
        validator: ETHValidator,
    },
    {
        name: "zkSync",
        symbol: "zksync",
        validator: ETHValidator,
    },
    {
        name: "Loopring",
        symbol: "lrc",
        validator: LRCValidator,
    },
    {
        name: "Starkware",
        symbol: "stark",
        validator: STARKWAREValidator,
    },
    {
        name: "Ronin",
        symbol: "ron",
        validator: RONValidator,
    },
    {
        name: "Immutable",
        symbol: "imx",
        validator: ETHValidator,
    },
    {
        name: "Harmony",
        symbol: "one",
        validator: ONEValidator,
    },
    {
        name: "Shiba Inu",
        symbol: "shib",
        validator: ETHValidator,
    },
    {
        name: "Pax Dollar",
        symbol: "usdp",
        validator: ETHValidator,
    },
    {
        name: "Wrapped Ethereum",
        symbol: "weth",
        validator: ETHValidator,
    },
    {
        name: "Flow",
        symbol: "flow",
        validator: FLOWValidator,
    },
    {
        name: "Fantom",
        symbol: "ftm",
        validator: ETHValidator,
    },
    {
        name: "NEAR",
        symbol: "near",
        validator: NEARValidator,
    },
    {
        name: "Cronos",
        symbol: "cro",
        validator: ETHValidator,
    },
    {
        name: "Thorchain",
        symbol: "thorchain",
        validator: THORCHAINValidator,
    },
    {
        name: "Helium",
        symbol: "hnt",
        validator: BTCValidator,
        expectedLength: 38,
        customLength: 37,
        addressTypes: { prod: ["00"] },
    },
    {
        name: "Boba",
        symbol: "boba",
        validator: ETHValidator,
    },
    {
        name: "Aurora",
        symbol: "aurora",
        validator: ETHValidator,
    },
    {
        name: "Moonriver",
        symbol: "movr",
        validator: ETHValidator,
    },
    {
        name: "Metis",
        symbol: "metis",
        validator: ETHValidator,
    },
    {
        name: "ZKSpace",
        symbol: "zks",
        validator: ETHValidator,
    },
    {
        name: "Kadena",
        symbol: "kda",
        validator: KDAValidator,
    },
    {
        name: "Elrond",
        symbol: "egld",
        validator: EGLDValidator,
    },
    {
        name: "MobileCoin",
        symbol: "mob",
        validator: MOBValidator,
    },
    {
        name: "ZKSync V2",
        symbol: "zksync2",
        validator: ETHValidator
    },
    {
        name: "SX Network",
        symbol: "sx",
        validator: ETHValidator
    },
    {
        name: "Kintsugi",
        symbol: "kint",
        prefix: 2092,
        validator: DOTValidator
    },
    {
        name: 'Chia',
        symbol: 'xch',
        validator: XCHValidator,
    },
    {
        name: 'Persistence',
        symbol: 'xprt',
        validator: XPRTValidator,
    },
    {
        name: "Peer",
        symbol: "peer",
        prefix: 42,
        validator: DOTValidator
    },
    {
        name: "Astar",
        symbol: "astr",
        prefix: 5,
        validator: DOTValidator
    },
    {
        name: "Bifrost Kusama",
        symbol: "bnc",
        prefix: 6,
        validator: DOTValidator
    },
    {
        name: "Bajun",
        symbol: "baju",
        prefix: 1337,
        validator: DOTValidator
    },
    {
        name: "Basilisk",
        symbol: "bsx",
        prefix: 10041,
        validator: DOTValidator
    },
    {
        name: "Linea",
        symbol: "linea",
        validator: ETHValidator
    },
    {
        name: "Reserve Block",
        symbol: "rbx",
        validator: RBXValidator
    },
    {
        name: "Oasys",
        symbol: "oas",
        validator: ETHValidator
    },
    {
        name: "Karura",
        symbol: "kar",
        prefix: 8,
        validator: DOTValidator
    },
    {
        name: "Aptos",
        symbol: "apt",
        validator: APTValidator
    },
    {
        name: "Sui",
        symbol: "sui",
        validator: SUIValidator
    },
    {
        name: "Ton",
        symbol: "ton",
        validator: TONValidator
    },
    {
        name: 'dYdX',
        symbol: 'dydx',
        validator: DYDXValidator,
    },
    {
        name: 'dYdX Testnet',
        symbol: 'dydxtestnet',
        validator: { isValidAddress: () => true },
    },
    {
        name: 'Interlay',
        symbol: 'intr',
        prefix: 2032,
        validator: DOTValidator
    },
    {
        name: "AlephZero",
        symbol: "azero",
        prefix: 42,
        validator: DOTValidator
    },
    {
        name: "Mantle",
        symbol: "mnt",
        validator: ETHValidator
    },
    {
        name: "Base",
        symbol: "base",
        validator: ETHValidator
    },
    {
        name: "Coreum",
        symbol: "coreum",
        validator: COREUMValidator
    },
    {
        name: "Komodo",
        symbol: "kmd",
        validator: KMDValidator
    },
    {
        name: "Internet Computer",
        symbol: "icp",
        validator: ICPValidator
    },
    {
        name: "Bifrost Polkadot",
        symbol: "bncpolka",
        prefix: [6, 0],
        validator: DOTValidator
    },
    {
        name: "Asset Hub",
        symbol: "assethub",
        prefix: 0,
        validator: DOTValidator
    },
    {
        name: "Acala",
        symbol: "aca",
        prefix: 10,
        validator: DOTValidator
    },
    {
        name: "Spiritnet",
        symbol: "kilt",
        prefix: 38,
        validator: DOTValidator
    },
    {
        name: "Pendulum",
        symbol: "pen",
        prefix: 56,
        validator: DOTValidator
    },
    {
        name: "Lightning Invoice",
        symbol: "ln",
        addressTypes: { prod: ["00", "05"], testnet: ["6f", "c4"] },
        validator: LNValidator,
    },
    {
        name: "HydraDX",
        symbol: "hdx",
        prefix: 63,
        validator: DOTValidator
    },
    {
        name: "Vara Network",
        symbol: "vara",
        prefix: 137,
        validator: DOTValidator
    },
    {
        name: "Zeitgeist",
        symbol: "ztg",
        prefix: 73,
        validator: DOTValidator
    },
    {
        name: "Bahamut",
        symbol: "bahamut",
        validator: ETHValidator
    },
    {
        name: "Build everything On Bitcoin",
        symbol: "bob",
        validator: ETHValidator
    },
    {
        name: "Alephium",
        symbol: "alph",
        validator: ALPHValidator
    },
    {
        name: "Venom",
        symbol: "venom",
        validator: VENOMValidator
    },
    {
        name: "Flow EVM",
        symbol: "flow-evm",
        validator: ETHValidator
    },
    {
        name: "Fuel Network",
        symbol: "fuel",
        validator: FUELValidator
    },
    {
        name: "BitKub",
        symbol: "bitkub",
        validator: ETHValidator
    },
    {
        name: "Worldchain",
        symbol: "wld",
        validator: ETHValidator
    },
    {
        name: "Rollux",
        symbol: "rollux",
        validator: ETHValidator
    },
    {
        name: "Polimec",
        symbol: "plmc",
        prefix: 41,
        validator: DOTValidator
    },
    {
        name: "Mythos",
        symbol: "myth",
        validator: ETHValidator
    },
    {
        name: "GalaChain",
        symbol: "galachain",
        validator: GALACHAINValidator
    },
    {
        name: "Glue",
        symbol: "glue",
        validator: ETHValidator
    },
    {
        name: "Sonic",
        symbol: "s",
        validator: ETHValidator
    },
    {
        name: "Pi",
        symbol: "pi",
        validator: XLMValidator
    },
    {
        name: "VerifiedX",
        symbol: "verifiedx",
        validator: RBXValidator
    },
    {
        name: "Sophon",
        symbol: "sophon",
        validator: ETHValidator
    },
    {
        name: "Unichain",
        symbol: "unichain",
        validator: ETHValidator
    },
    {
        name: "HashKeyChain",
        symbol: "hsk",
        validator: ETHValidator
    },
    {
        name: "Soneium",
        symbol: "soneium",
        validator: ETHValidator
    },
    {
        name: "Lisk",
        symbol: "lisk",
        validator: ETHValidator
    },
    {
        name: "ImmutablezkEVM",
        symbol: "immutable-zkevm",
        validator: ETHValidator
    },
    {
        name: "DEnergy",
        symbol: "denergy",
        validator: ETHValidator
    },
    {
        name: "Injective",
        symbol: "inj",
        validator: INJValidator
    },
    {
        name: "Flux",
        symbol: "flux",
        expectedLength: 26,
        addressTypes: { prod: ['1cb8', '1cbd'], testnet: ['1cb8', '1cbd'] },
        validator: BTCValidator
    },
    {
        name: "QuantumResistantLedger",
        symbol: "qrl",
        validator: QRLValidator
    },
    {
        name: "ApeChain",
        symbol: "APE",
        validator: ETHValidator
    },
    {
        name: "Aleph Zero EVM",
        symbol: "AZERO-EVM",
        validator: ETHValidator
    },
    {
        name: "Kinesis",
        symbol: "KINESIS",
        validator: XLMValidator,
    },
    {
        name: "Polymesh",
        symbol: "POLYX",
        prefix: 12,
        validator: POLYXValidator,
    },
    {
        name: "Pulsechain",
        symbol: "PLS",
        validator: ETHValidator,
    },
    {
        name: "Viction",
        symbol: "VIC",
        validator: ETHValidator,
    },
    {
        name: "Gunz",
        symbol: "GUNZ",
        validator: ETHValidator,
    },
    {
        name: "Concordium",
        symbol: "CCD",
        validator: CCDValidator,
    },
    {
        name: "Ink",
        symbol: "INK",
        validator: ETHValidator,
    },
    {
        name: "SupraMove",
        symbol: "SUPRA",
        validator: SUPRAValidator,
    },
    {
        name: "QuantumCoin",
        symbol: "Q",
        validator: QValidator,
    },
    {
        name: "Eclipse",
        symbol: "ECLIPSE",
        validator: SOLValidator,
    },
    {
        name: "Somnia",
        symbol: "SOMI",
        validator: ETHValidator,
    },
    {
        name: "Peaq",
        symbol: "PEAQ-EVM",
        validator: ETHValidator,
    },
    {
        name: "Ergo",
        symbol: "ERG",
        validator: ERGOValidator,
    },
    {
        name: "Etherlink",
        symbol: "ETHERLINK",
        validator: ETHValidator,
    },
];

const defaultIfNotFound = {
    name: 'ValidatorSkip',
    symbol: '',
    validator: { isValidAddress: () => true },
};

export const getByNameOrSymbol = (currencyNameOrSymbol) => {
    const nameOrSymbol = currencyNameOrSymbol.replace(' ', '').toLowerCase(); // Remove spaces and make lowercase
    
    return (
        CURRENCIES.find(
            (currency) => currency.symbol.replace(' ', '').toLowerCase() === nameOrSymbol,
        ) || defaultIfNotFound
    );
}
